export enum EAffinyEventOrigin {
  W_BAL = 'W_BAL', // Inbox
  W_PVIEW_DISPLAY = 'W_PVIEW_DISPLAY', // Profile display
  W_PP_FAV_STAR = 'W_PP_FAV_STAR', // Add to my favorite
  W_FAV_S = 'W_FAV_S', // Favorite sent
  W_FAV_R = 'W_FAV_R', // Favorite recevied
  W_VIEW_R = 'W_VIEW_R', // Photo reveal and Photo request
  W_ML = 'W_ML', // Matchlist
  W_PP_YES = 'W_PP_YES', // Favorite sent on Discover
  W_PP_SEND = 'W_PP_SEND', // Message sent after Favorite sent on Discover
  W_PP_NO = 'W_PP_NO', // Decline on Discover
  W_PP_MAIL = 'W_PP_MAIL', // Message sent on Discover
  W_PD_MAIL = 'W_PD_MAIL', // Message sent on Profile Display
  W_PD_SEND = 'W_PD_SEND', // Message sent after Favorite sent on Profile display
  W_PD_FAV_HEADER = 'W_PD_FAV_HEADER', // Favorite from Profile display header
  W_PD_FAV_FOOTER = 'W_PD_FAV_FOOTER', // Favorite from Profile display footer
  W_FAV_RECEIVED_MAIL = 'W_FAV_RECEIVED_MAIL', // Message sent on Inbox from favotite received
  W_FAV_SEND_MAIL = 'W_FAV_SEND_MAIL', // Message sent on Inbox from favotite sent
  W_VISIT_RECEIVED_MAIL = 'W_VISIT_RECEIVED_MAIL', // Message sent on Inbox from visits
}
